import { QarepaEnumInformation } from '@qarepa/common';

export enum EmployeeCheckTypeEnum {
  REMOTE_QR = 'REMOTE_QR',
  REMOTE_PIN = 'REMOTE_PIN',
  REMOTE_NFC = 'REMOTE_NFC',
  IN_PERSON_QR = 'IN_PERSON_QR',
  IN_PERSON_PIN = 'IN_PERSON_PIN',
  IN_PERSON_NFC = 'IN_PERSON_NFC',
  DESKTOP = 'DESKTOP',
  WEB = 'WEB',
  ANDROID = 'ANDROID',
  IOS = 'IOS',
}

export const EmployeeCheckTypeInfo: QarepaEnumInformation<EmployeeCheckTypeEnum> =
  {
    [EmployeeCheckTypeEnum.REMOTE_QR]: { name: 'QR DEL EMPLEADO' },
    [EmployeeCheckTypeEnum.REMOTE_PIN]: { name: 'PIN DEL EMPLEADO' },
    [EmployeeCheckTypeEnum.REMOTE_NFC]: { name: 'NFC' },
    [EmployeeCheckTypeEnum.IN_PERSON_QR]: { name: 'QR DEL EMPLEADO' },
    [EmployeeCheckTypeEnum.IN_PERSON_PIN]: { name: 'PIN DEL EMPLEADO' },
    [EmployeeCheckTypeEnum.IN_PERSON_NFC]: { name: 'NFC' },
    [EmployeeCheckTypeEnum.DESKTOP]: { name: 'DESKTOP' },
    [EmployeeCheckTypeEnum.WEB]: { name: 'WEB' },
    [EmployeeCheckTypeEnum.ANDROID]: { name: 'MOBILE' },
    [EmployeeCheckTypeEnum.IOS]: { name: 'MOBILE' },
  };
